import React, { useState } from "react";
import { bookExamples } from "../../data/bookExamples";

// Cover lookup for REAL (Library-flow) CraftPrints, keyed by numeric book_id.
export function coverForBookId(bookId) {
  const b = bookExamples.find((x) => String(x.id) === String(bookId));
  return b?.coverUrl || b?.image || null;
}

export function CoverThumb({ src, title, testId }) {
  const [state, setState] = useState(src ? "loading" : "failed");
  return (
    <div className="mc-active-cover mc-cover-frame" data-testid={`${testId}-frame`} data-state={state}>
      {state !== "loaded" && (
        <span className="mc-cover-fallback" aria-hidden="true">{(title || "").slice(0, 28)}</span>
      )}
      {src && state !== "failed" && (
        <img
          src={src}
          alt={`${title} cover`}
          data-testid={testId}
          onLoad={(e) => setState(e.currentTarget.naturalWidth > 10 ? "loaded" : "failed")}
          onError={() => setState("failed")}
          style={{ opacity: state === "loaded" ? 1 : 0 }}
        />
      )}
    </div>
  );
}
